module.exports = __webpack_public_path__ + "static/media/Материали и предложения за решения.038a857a.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/informationInversors/2022/Материали и предложения за решения.pdf
// module id = 100
// module chunks = 0